import { Module } from 'vuex'
import { categories as categoriesApi } from '@youwish1/api-package'

export const categories: Module<{}, {}> = {
  namespaced: true,

  actions: {
    async all() {
      const response = await categoriesApi.all()

      return response
    },
  },
}
